import * as React from "react";
import { useMemo } from "react";
import { Badge } from "common/components";
function VulnerabilitiesCount({ vulnerabilities }) {
  const count = useMemo(() => {
    const uniqueVulnerabilitiesIds = /* @__PURE__ */ new Set();
    vulnerabilities.forEach((vuln) => {
      (vuln.vulnerabilities || []).forEach((inVuln) => {
        uniqueVulnerabilitiesIds.add(`${inVuln.vulnerability_id}${inVuln.cve}`);
      });
    });
    return uniqueVulnerabilitiesIds.size;
  }, [vulnerabilities]);
  if (!vulnerabilities.length) return null;
  return /* @__PURE__ */ React.createElement(Badge, null, count);
}
export default VulnerabilitiesCount;
